<template>
    <div class="inner-box">
        <!-- AS 접수이력 그리드 s.-->
        <div class="table-area">
            <div class="table-b">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name">{{ `AS접수이력` }}</h3>
                    </div>
                    
                    <div class="grid-tbl-box">
                        <ag-grid-vue 
                            ref="grid" 
                            :style="gridStyle"
                            class="ag-theme-alpine"
                            :enableRangeSelection="true"
                            :column-defs="columnDefs"
                            :grid-options="gridOptions"
                            :row-data="data"
                            :default-col-def="defaultColDef"
                            :framework-components="frameworkComponent"
                            @grid-ready="onReadyMain"
                            :statusBar="statusBar"
                            @cell-clicked="onCellClicked" />
                    </div>
                </div>
            </div>
        </div>
        <!-- AS 접수이력 그리드 e.-->
    </div>
</template>


<script>
/**
 * * mixins
 */
import slip from '@/mixin/slip';
import common from '@/mixin/common';

/**
 * * components
 */
import {AgGridVue} from 'ag-grid-vue';
import DhxCalendar from '@/components/Dhx/DhxCalendar.vue';

/**
 * * Modal
 */
import ReceptionModal from '@/components/AS/History/Modal/ReceptionModal.vue';

export default {
    mixins: [slip, common],
    components: {AgGridVue, DhxCalendar},
    props: ['custParam'],
    data() {
        return {
            data: [],
            // AG-GRID OPTION [START]
            gridStyle : 'padding-top: 40px; width: 100%;height: 500px; min-height:100px;',
            defaultColDef: {
                resizable: true
                , filter: true
                , sortable: true
            },
            gridApi: null,
            columnApi: null,
            columnDefs: [],
            gridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            frameworkComponent : {
                
            },
            statusBar: null,
            //AG-GRID OPTION [END]
        }
    },
    computed: {
        
    },
    created() {
        this.statusBar = {
            statusPanels: [
                { statusPanel: 'agTotalRowCountComponent', align: 'right' },
            ],
        };
    },
    mounted() {
        // this.data = [{rcptDt: '20230102'},{rcptDt: '20230102'}]
        this.setHistoryList();
    },
    methods: {
        onReadyMain() { 
            //메인그리드 api 정의
            this.gridApi = this.gridOptions.api;
            this.columnApi = this.gridOptions.columnApi;
            this.createColumnDefs();
        },
        createColumnDefs() {
            const vm = this;
            this.columnDefs = [
                {
                    headerName:'No',
                    field:'no', 
                    width:70,
                    cellStyle:{textAlign: 'center'},
                    valueFormatter: function(params) {               
                        return params.node.rowIndex+1;
                    },
                },
                {
                    headerName:'접수일자', 
                    field:'callDt', 
                    width: 110,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                    cellRenderer: (params) => {
                        if(params.value && params.value.length >= 10){
                            params.value =  params.value.substring(0,10)
                        }
                        return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
                    }
                },
                {
                    headerName:'접수유형',
                    field:'asClass2Nm', 
                    width: 110,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'제조사',
                    field:'makerNm', 
                    width: 110,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'제품군',
                    field:'modelGroupNm', 
                    width: 100,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'모델',
                    field:'modelNm', 
                    width: 140,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'처리모델',
                    field:'prcsModelNm', 
                    width: 120,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                    valueFormatter: function(params) {
                        return parseInt(params.data.qty) === 1 ? params.value : ``;
                    },
                },
                {
                    headerName:'제조번호',
                    field:'serialNo', 
                    width: 120,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                    valueFormatter: function(params) {
                        return parseInt(params.data.qty) === 1 ? params.value : ``;
                    },
                },
                {
                    headerName:'대수',
                    field:'qty', 
                    width: 70,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'증상구분',
                    field:'asCat1LvlNm', 
                    width: 110,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'고장증상',
                    field:'asCatNm', 
                    width: 130,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'처리센터',
                    field:'allocationAsAgentNm', 
                    width: 110,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'처리결과',
                    field:'asStatusNm', 
                    width: 110,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'접수자',
                    field:'creatorNm', 
                    width: 130,
                    editable: false,
                    cellStyle:{textAlign:'center'},
                },
                {
                    headerName:'접수ID',
                    field:'asId', 
                    width: 110,
                    editable: false,
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName:'신고자명',
                    field:'boundCustNm', 
                    width: 110,
                    editable: false,
                    cellStyle:{textAlign:'center'}
                }
            ]
        },
        onCellClicked(params) {
            //const idx = params.rowIndex;
            const field = params.colDef.field;
            if(field === 'callDt') {
                this.openModel(params.data);
            }
        },
        proc() {
            
        },
        setHistoryList(param) {
            console.log('setHistoryList start: ', this.custParam.callAsCustSelPageList)
            //this.data = []
            //Object.assign(this.data, this.custParam.callAsCustSelPageList);
            //console.log('setHistoryList start this.data: ', this.data)

            let catObj = [];
            let histObj = [];

            if(param){
                histObj = param.callAsCustSelPageList || [];
                catObj = param.getAsStatus || [];
            } else {
                histObj = this.custParam.callAsCustSelPageList || [];
                catObj = this.custParam.getAsStatus || [];
            }
console.log('==setHistoryList catObj: ', catObj)

            // 조회목록에서 코드를 명칭으로 변환처리
            histObj.map((x, i) => {

                if(x.asParentClassNm === ''){
                    x.asClass2Nm = x.asClassNm;
                }else {
                    x.asClass2Nm = x.asParentClassNm + '/' + x.asClassNm;
                }
                
                const str = x.asCatFullNm
                if (typeof str === 'string') {
                    const arr1 = str.split('>');
                    if(arr1){
                        x.asCat1LvlNm = arr1[1] || '';   // 증상구분
                    } 
                }

                if(catObj){
                    let asStatusObj = catObj.filter(y => y.catLvl==3 && y.catKey === x.asStatus) || [];
                    if(asStatusObj && asStatusObj.length>0){
                        x.asStatusNm = asStatusObj[0].catNm || ''; // 처리결과
                    } else {
                        asStatusObj = catObj.filter(y => y.catLvl==2 && y.catKey === x.asStatus) || [];
                        if(asStatusObj && asStatusObj.length>0){
                            x.asStatusNm = asStatusObj[0].catNm || ''; // 처리결과
                        }
                    }
                }
                
                x.no = i+1;
                return x;
            })

  
            this.data = histObj || []
        },
        /**
         * 접수/처리 상세 팝업 오픈
         */
         openModel(param) {
            let vm = this;
            const vPopHeadInfo = {
                ...this.custParam.popHeadInfo,
                boundCustNm : param.boundCustNm
            }
            this.$modal.open({
                width: 800,
                component: ReceptionModal,
                parent: this,
                props: {
                    data: {
                        asId: param.asId,
                        custId: param.custId,
                        sortType: '',
                        popHeadInfo: vPopHeadInfo,
                        //reqDt: this.$moment('20230101').format('YYYY-MM-DD'),
                        recptDt: this.$moment(param.callDt).format('YYYY-MM-DD'),
                        procsDt: this.$moment(param.procDt).format('YYYY-MM-DD')
                    }
                },
                events: {
                    close(data) {
                        console.log('close', data);
                    },
                }
            });
        },
    }
}
</script>

<style scoped>
.el-form {
    border: 1px solid #c7c7c7;
    padding: 10px;
    border-radius: 5px;
}
</style>